// extracted by mini-css-extract-plugin
module.exports = {"layoutIcon":"Shop_layoutIcon_1CHin","layoutIconActive":"Shop_layoutIconActive_L68t1"};